export const getSelectedField = (state) => {
    return state.privateData.selectedField;
};
